export const KEYBOARD_STRING = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const KEYBOARD = KEYBOARD_STRING.split('');
